export const eventHeader = [
  { id: "title", label: "Title", minWidth: 160 },
  { id: "venue", label: "Venue", minWidth: 120 },
  { id: "eventdate", label: "Event Date", minWidth: 130 },
];

export const articleHeader = [
  { id: "title", label: "Title", minWidth: 160 },
  { id: "author", label: "Author", minWidth: 120 },
  { id: "createdAt", label: "Published", minWidth: 130 },
];

export const galleryHeader = [
  { id: "title", label: "Title", minWidth: 160 },
  { id: "imgSrc", label: "Image", minWidth: 100, type: "image" },
  { id: "createdAt", label: "Uploaded", minWidth: 130 },
];

export const adminHeader = [
  { id: "name", label: "Name", minWidth: 130 },
  { id: "email", label: "Email", minWidth: 160 },
  { id: "role", label: "Role", minWidth: 100 },
  { id: "createdAt", label: "Member Since", minWidth: 130 },
];

export const notificationHeader = [
  { id: "name", label: "Admin", minWidth: 130 },
  { id: "message", label: "Activity", minWidth: 220 },
  { id: "createdAt", label: "Date", minWidth: 130 },
];

export const authorHeader = [
  { id: "imgSrc", label: "Photo", minWidth: 80, type: "image" },
  { id: "name", label: "Name", minWidth: 130 },
  { id: "email", label: "Email", minWidth: 160 },
  { id: "phone", label: "Phone", minWidth: 120 },
  { id: "category", label: "Category", minWidth: 130 },
  { id: "status", label: "Status", minWidth: 100, type: "status" },
];

export const memberHeader = [
  { id: "imgSrc", label: "Photo", minWidth: 80, type: "image" },
  { id: "name", label: "Name", minWidth: 130 },
  { id: "gender", label: "Gender", minWidth: 90 },
  { id: "dob", label: "Birthday", minWidth: 100 },
  { id: "familyName", label: "Family", minWidth: 120 },
  { id: "status", label: "Status", minWidth: 100, type: "status" },
];

export const tractHeader = [
  { id: "title", label: "Title", minWidth: 160 },
  { id: "link", label: "Link", minWidth: 120, type: "link" },
  { id: "monthYear", label: "Tract Month", minWidth: 130 },
  { id: "createdAt", label: "Date", minWidth: 130 },
];

export const familyHeader = [
  { id: "familyName", label: "Family Name", minWidth: 160 },
  { id: "familyCount", label: "Members", minWidth: 100 },
  { id: "createdAt", label: "Created", minWidth: 130 },
];
